import { render } from "./EasyTalkPayPage.vue?vue&type=template&id=d3c203a4"
import script from "./EasyTalkPayPage.vue?vue&type=script&lang=js"
export * from "./EasyTalkPayPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__